import Modal from "bootstrap/js/dist/modal";

document.querySelectorAll('.leader-modal-trigger').forEach(function (leaderModal) {
  const modalElement = document.getElementById('leaderModal');
  const modal = new Modal(document.getElementById('leaderModal'));
  modalElement.querySelector('[data-bs-dismiss="modal"]').addEventListener('click', () => modal.hide());
  leaderModal.addEventListener('click', (e) => {
    e.preventDefault();
    modal.show();
  });
});

document.querySelectorAll('.expert-modal-trigger').forEach(function (expertModal) {
  const modalElement = document.getElementById('expertModal');
  const modal = new Modal(document.getElementById('expertModal'));
  modalElement.querySelector('[data-bs-dismiss="modal"]').addEventListener('click', () => modal.hide());
  expertModal.addEventListener('click', (e) => {
    e.preventDefault();
    modal.show();
  });
});
